import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-j-message-article-panel-body p-j-message-article-panel-body--col" }
const _hoisted_2 = { class: "p-j-message-article-panel-body__user-data" }
const _hoisted_3 = { class: "p-j-message-article-panel-body__user-line" }
const _hoisted_4 = {
  class: "p-j-message-article-panel-body__name",
  "data-translate-skip": ""
}
const _hoisted_5 = {
  class: "p-j-message-article-panel-body__id",
  "data-translate-skip": ""
}
const _hoisted_6 = {
  class: "p-j-message-article-panel-body__group",
  "data-translate-skip": ""
}
const _hoisted_7 = { class: "p-j-message-article-panel-body__content" }
const _hoisted_8 = {
  class: "message-link",
  "data-translate-skip": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.name), 1),
        _createElementVNode("div", _hoisted_5, " ID:" + _toDisplayString(_ctx.id), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.groupName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.truncate(_ctx.content, 62)), 1)
    ])
  ]))
}